// extracted by mini-css-extract-plugin
module.exports = {"root":"SimpleBadge_root__3bNdO"};